<template>
  <div>
    <q-dialog ref="dialog" @hide="onDialogHide">
      <q-card class="q-dialog-plugin">
        <q-card-section class="row justify-center">
          <q-icon name="error_outline" color="warning" size="4.5em"></q-icon>
        </q-card-section>
         <q-form
            @submit="()=>{
                let params = {reason, event: this._event}
                if(reason) {
                    this.$emit('on-ok-click',params)
                }
            }"
            class="q-gutter-md"
        >
            <q-card-section class="row justify-center q-mx-lg">
            <span class="text-subtitle1 text-weight-medium text-center">
                <translate>REASON_TO_HOLD_ORDER</translate>
            </span>
            <q-input v-model="reason" style="width:100%" :rules="[ val => val && val.length > 0]"></q-input>
            </q-card-section>
            <q-card-actions class="justify-center q-pa-md q-my-sm">
            <q-btn
                :label="$gettext('DIALOGS_NO')"
                color="grey-7"
                @click="onCancelClick"
                class="q-px-lg"
            />
            <q-btn
                :label="$gettext('DIALOGS_YES')"
                color="info"
                type="submit"
                class="q-px-lg"
            />
            </q-card-actions>
        </q-form>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { QDialog, Dialog } from 'quasar'
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'billingOrderDialogHoldOrder',
  components: {
    QDialog,
    Dialog
  },
  props: {
    reason: String
  }
})
class BillingOrderDialogHoldOrder extends Vue {
  reason = null;
  _event = null;
  show (_event) {
    this._event = _event
    this.$refs.dialog.show()
  }

  hide () {
    this.$refs.dialog.hide()
    this.reason = null
  }

  onDialogHide () {
    this.$emit('hide')
  }

  onOKClick () {
    this.$emit('ok')
    this.hide()
  }

  onCancelClick () {
    this._event.props.row.holdOrder = false
    this.hide()
  }
}
export default BillingOrderDialogHoldOrder
</script>
<style lang="stylus" scoped></style>
